import React from 'react';
import SoftwareHero from './components/SoftwareHero';
import ServicesOverview from './components/ServicesOverview';
import DevelopmentProcess from './components/DevelopmentProcess';
import TechStack from './components/TechStack';
import WhyChooseUs from './components/WhyChooseUs';
import ContactFormWidget from '../../../components/ContactFormWidget';
import Footer from '../../../components/Footer';

const SoftwareDevelopment = () => {
  return (
    <div className="software-development-page">
      <SoftwareHero />
      <ServicesOverview />
      <DevelopmentProcess />
      <TechStack />
      <WhyChooseUs />
      <ContactFormWidget />
      <Footer />
    </div>
  );
};

export default SoftwareDevelopment; 